<template>
  <div>
    <collapse title="Explicación y justificación del contrato">
      <validation-provider
        v-if="!isReadOnly"
        v-slot="{ errors }"
        :custom-messages="{
          required:
            'Debe indicar por qué el DEPR no puede proveer el servicio.',
        }"
        rules="required"
      >
        <custom-text-area
          v-model="model"
          :count-classes="['d-block', 'small-counter']"
          :custom-error-msg="errors[0]"
          :error="errors[0]"
          label="¿Por qué el Departamento de Educación de Puerto Rico no puede proveer los servicios? Los servicios profesionales solo se deben contratar si el Departamento de Educación de Puerto Rico no tiene los recursos internos necesarios o especializados para brindarlos."
          :maxlength="10000"
          show-char-count
        />
      </validation-provider>
      <div v-else-if="isReadOnly" class="my-2">
        <div class="my-2">
          ¿Por qué el Departamento de Educación de Puerto Rico no puede proveer
          los servicios? Los servicios profesionales solo se deben contratar si
          el Departamento de Educación de Puerto Rico no tiene los recursos
          internos necesarios o especializados para brindarlos.
        </div>
        <label class="data-label">
          {{ model | empty }}
        </label>
      </div>
    </collapse>
  </div>
</template>
<script>
import Collapse from '@/components/common/SimpleCollapse.vue';
import CustomTextArea from 'CustomTextArea';

export default {
  name: 'ContractJustification',
  components: {
    Collapse,
    CustomTextArea,
  },
  props: {
    value: {
      type: String,
      default: () => '',
    },
    isReadOnly: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>
